import { useState, useEffect } from 'react';

const STORAGE_KEY = 'task-toggle-preference';

export const useTaskTogglePreference = (): [
  boolean | null,
  (value: boolean) => void
] => {
  const [preference, setPreference] = useState<boolean | null>(() => {
    try {
      const storedValue = localStorage.getItem(STORAGE_KEY);
      return storedValue !== null ? JSON.parse(storedValue) : null;
    } catch {
      return null;
    }
  });

  useEffect(() => {
    if (preference !== null) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(preference));
      } catch (error) {
        console.error('Error writing to localStorage', error);
      }
    }
  }, [preference]);

  return [preference, setPreference];
};

export default useTaskTogglePreference;
